import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { GrClose } from 'react-icons/gr';
const PopupAlert = () => {
  const [showPopup, setShowPopup] = useState(false);

  const handleClick = () => {
    setShowPopup(false);
  };
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowPopup(true);
    }, 4000);
    document.addEventListener('click', handleClick);
    return () => {
      clearTimeout(timer);
      document.removeEventListener('click', handleClick);
    };
  }, []);
  if (!showPopup) {
    return null;
  }
  return ReactDOM.createPortal(
    <div className="popup-container">
      <div className="popup-background"></div>
      <div className="popup">
        <div className="box">
          <div className="crose-icon"><GrClose /></div>
          <div className="text-center">
            {/* <img src="../img/popup.gif" className="w-50" alt="Owner Image" /> */}
            <img src="../img/popup.webp" className="w-50" alt="Owner Image" />
            <h4 className="py-3">Welcome to Muhammad Rizwan's Development Hub!</h4>
            <p>Welcome to my personal corner of the web! Thrilled to have you here. Explore a universe of possibilities tailored just for you. From captivating design to top-notch services, this space is crafted with care. Join me on this journey, and let's turn your ideas into reality together.</p>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};
export default PopupAlert;